import * as React from 'react';
import Select from 'react-select';
import DatePicker  from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as Moment from 'moment'

//import Select from 'react-select';
import { Link } from 'react-router-dom';
import {User} from '../../_models/User'
import {themeStyles, customSelectStyles} from '../campaign/themeStyles.js'
import * as controller from './controller'
import { withLocalize, Translate } from "react-localize-redux";
import BarGraph from './bar.jsx'
import PieGraph from './pie.jsx'
import './User.css';

class UserPage extends React.Component<any, any> {

  handleUserChange: any
  handleSelectChange: any
  updateUser:any
  picture: any
  constructor(props: any) {
    super(props);
    this.state = {
      user: new User(),
      picture: "",
      updating: false,
      showMore: false,
      categoryValue: "",
      categories: []
    }
    this.updateUser = controller.updateUser.bind(this)
    this.handleUserChange = controller.handleUserChange.bind(this)
  }




  componentDidMount() {
    if(this.props.match.params.id && !isNaN(this.props.match.params.id)) {
      this.loadUser(this.props.match.params.id)
    }

  }

  componentWillReceiveProps(nextProps: any) {
    if(nextProps.match.params.id
      && !isNaN(nextProps.match.params.id)
      && this.state.user.id != nextProps.match.params.id) {
      this.loadUser(nextProps.match.params.id)
    } else {
      this.setState({user: new User()})
    }
  }

  selectFile(input: any) {
    let file = this.picture.files[0]
     var reader = new FileReader();
     let user = this.state.user
     user.updated = false
     reader.onload = (e:any) => {
       if(e.target) {
         this.setState({picture: e.target.result, user})

       }
     }
     reader.readAsDataURL(file);
  }

  loadCategories() {
    fetch('categories/getAll', {
      method: 'POST'
    }).then(results => {
      return results.json();
    }).then(data => {
        let categories = data.categories.map((category: any) => {
          return {value: category.id, label: category.title}
        })

        this.setState({categories})
    }).catch(err => {
      //alert(err.message);
    })
  }

  loadUser(id:any) {
    fetch('users/get', {
      method: 'POST',
      body: JSON.stringify({id})
    }).then(results => {
      return results.json();
    }).then(data => {
        let user = new User(data.user)
        let categories = user.categories.map((category) => {
          return {value: category.id, label: category.title}
        })
        user.categories = categories
        this.setState({user}, ()=>{
          this.loadCategories()
        })

    }).catch(err => {
      alert(err.message);
    })
  }


  public render() {

    let user = this.state.user
    let url = this.state.picture.length? this.state.picture : process.env.REACT_APP_AWS+"/users/"+user.id+"/pictures/"+user.picture
    return (
      <div id="edit-account-root">
          <i onClick={() => {this.props.history.goBack()}} className="fas fa-times"></i>
          <form className="data">
            {((user.id && user.picture.length) || (this.state.picture.length))?
              (<div className="picture" style={{backgroundImage: "url("+url+")"}} onClick={() => {this.picture.click()}}></div>)
            : (<div className="picture" onClick={() => {this.picture.click()}}></div>)}

            <div className="third inputC">
              <label><Translate id="name" /></label>
              <input readOnly={window.account.type != "admin"} onChange={this.handleUserChange} value={user.name} name="name" placeholder={this.props.translate("name").toString()} />
            </div>

            {window.account.type == "admin" && <div>
              <div className="third inputC">
                <label><Translate id="phone" /></label>
                <input onChange={this.handleUserChange} value={user.phone} name="phone" placeholder={this.props.translate("phone").toString()} />
              </div>

              <div className="third inputC">
                <label><Translate id="email" /></label>
                <input onChange={this.handleUserChange} value={user.email} name="email" placeholder={this.props.translate("email").toString()} />
              </div>

              <div className="third inputC">
                <label><Translate id="address" /></label>
                <input onChange={this.handleUserChange} value={user.address} name="address" placeholder={this.props.translate("address").toString()} />
              </div>

              <div className="third inputC">
                <label><Translate id="city" /></label>
                <input onChange={this.handleUserChange} value={user.city} name="city" placeholder={this.props.translate("city").toString()} />
              </div>

              <div className="third inputC">
                <label><Translate id="postal" /></label>
                <input onChange={this.handleUserChange} value={user.postal} name="postal" placeholder={this.props.translate("postal").toString()} />
              </div>

              <div className="third inputC">
                <label><Translate id="price" /></label>
                <input onChange={this.handleUserChange} value={user.price || ""} name="price" placeholder={this.props.translate("price").toString()} />
              </div>

              <div className="third inputC">
              <label><Translate id="birthDate" /></label>
              <DatePicker
                selected={user.birthDate? user.birthDate.toDate() : null}
                onChange={(date:any) => {
                  let user = this.state.user
                  user.birthDate = Moment(date)
                  user.updated = false
                  this.setState({user})
                }}
                name="birthDate"
                dateFormat="dd/MM/yyyy"
                autoComplete="off"
              /></div>

              <div className="third inputC">
              <label><Translate id="sex" /></label>

              <Select
                placeholder={this.props.translate("sex").toString()}
                isRtl={(this.props.activeLanguage && this.props.activeLanguage.code == "he") ? true : false}
                theme={themeStyles}
                styles={customSelectStyles}
                className="multiSelect"
                classNamePrefix="react-select"
                onChange={(selectedOption: any) => {
                  let user = this.state.user
                  user.sex = selectedOption.value
                  user.updated = false
                  this.setState({user});
                }}
                value={user.sex=="male"? {value:"male", label:"זכר"} : user.sex=="female"? {value: "female", label: "נקבה"} : null}
                options={[{value:"male", label:"זכר"}, {value: "female", label: "נקבה"}]}
              /></div>

              <div className="third inputC">
                <label><Translate id="facebookProfile" /></label>
                <input onChange={this.handleUserChange} value={user.facebook} name="facebook" placeholder={this.props.translate("facebookProfile").toString()} />
              </div>

              <div className="third inputC">
                <label><Translate id="instagramProfile" /></label>
                <input onChange={this.handleUserChange} value={user.instagram} name="instagram" placeholder={this.props.translate("instagramProfile").toString()} />
              </div>

              <div className="third inputC">
                <label><Translate id="youtubeProfile" /></label>
                <input onChange={this.handleUserChange} value={user.youtube} name="youtube" placeholder={this.props.translate("youtubeProfile").toString()} />
              </div>

              {this.state.showMore && <div>

                <div className="third inputC">
                  <label><Translate id="user.maleFollowers" /></label>
                  <input onChange={this.handleUserChange} value={user.maleFollowers} name="maleFollowers" placeholder={this.props.translate("user.maleFollowers").toString()} />
                </div>


                <div className="third inputC">
                  <label><Translate id="user.ghostFollowers" /></label>
                  <input onChange={this.handleUserChange} value={user.ghostFollowers} name="ghostFollowers" placeholder={this.props.translate("user.ghostFollowers").toString()} />
                </div>

                <div className="third inputC">
                  <label><Translate id="user.israeliFollowers" /></label>
                  <input onChange={this.handleUserChange} value={user.israeliFollowers} name="israeliFollowers" placeholder={this.props.translate("user.israeliFollowers").toString()} />
                </div>

                <div className="third inputC">
                  <label><Translate id="user.teenagersFollowers" /></label>
                  <input onChange={this.handleUserChange} value={user.teenagersFollowers} name="teenagersFollowers" placeholder={this.props.translate("user.teenagersFollowers").toString()} />
                </div>

                <div className="third inputC">
                  <label><Translate id="user.studentFollowers" /></label>
                  <input onChange={this.handleUserChange} value={user.studentFollowers} name="studentFollowers" placeholder={this.props.translate("user.studentFollowers").toString()} />
                </div>

                <div className="third inputC">
                  <label><Translate id="user.youngFollowers" /></label>
                  <input onChange={this.handleUserChange} value={user.youngFollowers} name="youngFollowers" placeholder={this.props.translate("user.youngFollowers").toString()} />
                </div>


                <div className="third inputC">
                  <label><Translate id="user.adultFollowers" /></label>
                  <input onChange={this.handleUserChange} value={user.adultFollowers} name="adultFollowers" placeholder={this.props.translate("user.adultFollowers").toString()} />
                </div>


                <div className="third inputC">
                  <label><Translate id="user.oldFollowers" /></label>
                  <input onChange={this.handleUserChange} value={user.oldFollowers} name="oldFollowers" placeholder={this.props.translate("user.oldFollowers").toString()} />
                </div>


                <div className="third inputC">
                  <label><Translate id="user.avgLikes" /></label>
                  <input onChange={this.handleUserChange} value={user.avgLikes} name="avgLikes" placeholder={this.props.translate("user.avgLikes").toString()} />
                </div>

                <div className="third inputC">
                  <label><Translate id="user.avgComments" /></label>
                  <input onChange={this.handleUserChange} value={user.avgComments} name="avgComments" placeholder={this.props.translate("user.avgComments").toString()} />
                </div>

              </div>}




            </div>}

            {window.account.type == "client" && <div>
              <div className="third inputC">
                <label><Translate id="facebookProfile" /></label>
                <a href={user.facebook}><input readOnly={true} value={user.facebook} name="facebook" placeholder={this.props.translate("facebookProfile").toString()} /></a>
              </div>

              <div className="third inputC">
                <label><Translate id="instagramProfile" /></label>
                <a href={user.instagram}><input readOnly={true} value={user.instagram} name="instagram" placeholder={this.props.translate("instagramProfile").toString()} /></a>
              </div>

              <div className="third inputC">
                <label><Translate id="youtubeProfile" /></label>
                <a href={user.youtube}><input readOnly={true} value={user.youtube} name="youtube" placeholder={this.props.translate("youtubeProfile").toString()} /></a>
              </div>

            </div>}



            <div className="third inputC">
              <label><Translate id="facebookFollowers" /></label>
              <input readOnly={window.account.type != "admin"} onChange={this.handleUserChange} value={user.facebookFollowers || ""} name="facebookFollowers" placeholder={this.props.translate("facebookFollowers").toString()} />
            </div>

            <div className="third inputC">
              <label><Translate id="instagramFollowers" /></label>
              <input readOnly={window.account.type != "admin"} onChange={this.handleUserChange} value={user.instagramFollowers || ""} name="instagramFollowers" placeholder={this.props.translate("instagramFollowers").toString()} />
            </div>

            <div className="third inputC">
              <label><Translate id="youtubeFollowers" /></label>
              <input readOnly={window.account.type != "admin"} onChange={this.handleUserChange} value={user.youtubeFollowers || ""} name="youtubeFollowers" placeholder={this.props.translate("youtubeFollowers").toString()} />
            </div>

            <div className="third inputC">
            <label><Translate id="user.categories" /></label>

            <Select
              placeholder={this.props.translate("user.categories").toString()}
              isMulti
              isClearable
              isRtl={(this.props.activeLanguage && this.props.activeLanguage.code == "he") ? true : false}
              theme={themeStyles}
              styles={customSelectStyles}
              className="multiSelect"
              classNamePrefix="react-select"
              onChange={controller.handleCategoriesChange.bind(this)}
              value={user.categories}
              options={this.state.categories}
            /></div>

            {window.account.type == "admin" && <a className="showMore" onClick={()=>{this.setState({showMore: !this.state.showMore})}}>{this.state.showMore? this.props.translate("showLess").toString() : this.props.translate("showMore").toString()}</a>}

            <input style={{display: "none"}}  ref={el => this.picture = el} onChange={this.selectFile.bind(this, this.picture)} name="picture" type="file" />

            <div className="clearfix"></div>
            <h2 className="sectionHeader"><Translate id="user.instagramInfluence" />: {(user.instagramFollowers && user.avgLikes && user.avgComments)? ((parseInt(user.avgLikes) + parseInt(user.avgComments))/parseInt(user.instagramFollowers)*100).toFixed(2) : 0}%</h2>
            <h2 className="sectionHeader"><Translate id="user.avgLikesInstagram" />: {user.avgLikes && user.avgLikes.toLocaleString('us-EN')}</h2>
            <h2 className="sectionHeader"><Translate id="user.avgCommentsInstagram" />: {user.avgComments && user.avgComments.toLocaleString('us-EN')}</h2>
            <h2 className="sectionHeader"><Translate id="user.statisticsFor" /> {user.name}:</h2>
            <div style={{direction: "ltr"}} className="graphs">
                <div className="graph">
                  <h4><Translate id="campaign.followersSex" /></h4>
                  <PieGraph data={[
                    {name: this.props.translate("male").toString(), value: parseInt(user.maleFollowers), fill: '#2f98e0'},
                    {name: this.props.translate("female").toString(), value: 100-parseInt(user.maleFollowers) ,fill: '#fdb8f9'}
                  ]}/>
                </div>

                <div className="graph">
                  <h4><Translate id="campaign.followersOrigin" /></h4>
                  <PieGraph data={[
                    {name: this.props.translate("israelis").toString(), value: parseInt(user.israeliFollowers), fill: '#2f98e0'},
                    {name: this.props.translate("foreign").toString(), value: 100-parseInt(user.israeliFollowers) ,fill: '#9ad2f9'}
                  ]}/>
                </div>

                <div className="graph">
                  <h4><Translate id="campaign.inactiveFllowers" /></h4>
                  <PieGraph data={[
                    {name: 'Ghost', value: parseInt(user.ghostFollowers), fill: '#ccc'},
                    {name: this.props.translate("active").toString(), value: 100-parseInt(user.ghostFollowers) ,fill: '#2f98e0'}
                  ]}/>
                </div>

                <div className="graph">
                  <h4><Translate id="campaign.followersAges" /></h4>
                  <BarGraph data={[
                        {name: '<18', "%": parseInt(user.teenagersFollowers)},
                        {name: '19-24', "%": parseInt(user.studentFollowers)},
                        {name: '25-34', "%": parseInt(user.youngFollowers)},
                        {name: '35-45', "%": parseInt(user.adultFollowers)},
                        {name: '45+', "%": parseInt(user.oldFollowers)}
                      ]} />
                </div>

                <div className="clearfix"></div>
            </div>





            <div className="clearfix"></div>

            {window.account.type == "admin" && user.id && user.campaigns.length>0 && <div className="campaignSection">
              <h2>{user.name} <Translate id="user.participatingIn" />:</h2>
              {user.campaigns.map((campaign: any, i:number) => {
                return <Link to={"/campaigns/"+campaign.id} key={i}><div className="campaign" style={{backgroundImage: "url("+process.env.REACT_APP_AWS+"/campaigns/"+campaign.id+"/logos/"+campaign.logo+")"}}><span>{campaign.title}</span></div></Link>
              })}
              <div className="clearfix"></div>
            </div>}

            {window.account.type == "admin" &&  <div>
            <button className={"update "+((user.id && user.updated)? "updated" : "")} onClick={this.updateUser} disabled={user.updated || this.state.updating}>
            {this.state.updating? this.props.translate("updating").toString() :
              user.id? user.updated? this.props.translate("updated").toString() :
              this.props.translate("update").toString() :
              this.props.translate("save").toString()}            </button>
            <button className="primary-btn green" style={{width: "350px"}}><Translate id="resetPasswordAndSend" /></button>
            </div>}
          </form>
        </div>
    )
  }
}

export default withLocalize(UserPage)



// WEBPACK FOOTER //
// ./src/pages/user/User.tsx